
import './App.css';
import AppRouter from "./Routes/AppRouter";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <div className="App">
      <AppRouter />
     
    </div>
  );
}

export default App;
